import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";
import "office-ui-fabric-core/dist/css/fabric.css";

import reportWebVitals from "./reportWebVitals";
import { BrowserRouter } from "react-router-dom";
import { MicrosoftProvider } from "./auth/provider/microsoft-provider";

const root = ReactDOM.createRoot(document.getElementById("root") as HTMLElement);

root.render(
  <BrowserRouter>
    <MicrosoftProvider>
      <App />
    </MicrosoftProvider>
  </BrowserRouter>
);
reportWebVitals();
